import React, { useEffect, useState, useReducer, useRef } from 'react'
import { cloneDeep, debounce } from 'lodash'
import { Row, Col, Button, Icon, Tag, Tooltip, Popover } from '@tinper/next-ui'
import { FORM_SPANS } from '../../utils/constants'
import './style/index.less'
import { observer } from 'mobx-react'
import { autorun, reaction } from 'mobx'
import { v4 as uuid } from 'uuid'
import { getStyle, isDesinger } from './utils'
import addEventListener from 'rc-util/lib/Dom/addEventListener';
import FilterModal from '../QueryScheme/FilterModal/FilterModal'
import DataLoader from '../../utils/query_scheme/data_loader'

const AUTO_QUERY_DEBOUNCE = 500
const disposer = [];

const ConvenientQuery = props => {
  const { visible = true, alias,
    degignDomAttr = {}, // 设计器属性
    designDomClassName = '', // 设计器class
    $children,
    spans = FORM_SPANS, grid = 10,
    noBackground = false,
    bHideSearchStr = false, // 是否隐藏搜索按钮
    btnRestorelsHidden = false, // 是否隐藏重置按钮
    btnAdvanceIsHidden = false, // 是否隐藏高级按钮
    bHideSimpleSetting = false, // 是否隐藏调整按钮
    wrapDragable = false, // 外部容器是否可以被拖拽 eg：在树形控件上使用
    JSONSchema = {} // 描述组件的JSONSchema
  } = props

  const dataLoader = new DataLoader(props);

  const UUID = useRef(uuid())
  const comInitMaxDisplayNum = useRef()
  const chLen = useRef()
  const showChildren = useRef([])

  // 权限相关
  // const { search, reset } = authId //获取权限
  // bHideSearchStr = ctx?.getAuth?.(search)?.authFlag == false || bHideSearchStr
  // btnRestorelsHidden = ctx?.getAuth?.(reset)?.authFlag == false || btnRestorelsHidden
  let { cStyle } = props
  try {
    cStyle = JSON.parse(cStyle)
  } catch (error) { }

  const [isExpand, setExpand] = useState(!!wrapDragable)
  const [isFixed, setFix] = useState(false)
  const [allChildren, setAllChildren] = useState([])
  const [, forceRerender] = useReducer(x => x + 1, 0)
  const [queryAlias, setQueryAlias] = useState(`queryscheme_${UUID.current}`);
  const [originChildren, setOriginChildren] = useState([]) // 原字段集合(给设计器用)
  const [showModal, setShowModal] = useState(false)
  const [isEdit, setIsEdit] = useState(true)

  // 给store设置所有字段
  useEffect(() => {
    const originChildren = JSONSchema.initFiltersInfo?.($children)
    JSONSchema.setComponentInit?.()
    setOriginChildren(originChildren)
  }, [$children])

  // 没有查询方案不会触发-bug
  reaction(() => JSONSchema.isUpdate, () => {
    const _children = JSONSchema.getContitionList?.().filter(item => {
      return item.meta.storeField
    })
    setExpand(false) // 查询方案初始化显示展开按钮
    setAllChildren(_children || [])
    JSONSchema.setQueryReady?.() // 初始化的不要触发，否则扩展代码会进来，后又走了一遍查询方案会把扩展给刷没了
  })

  // ComponentDidMount
  useEffect(() => {
    JSONSchema.setUpdate?.()
    JSONSchema.initParams?.(dataLoader.getParams)
    let keydownHandler = addEventListener(document, 'keydown', debounce(e => onFilterKeyDown(e), 300));
    // ComponentWillUnMount
    return () => {
      keydownHandler.remove()
      keydownHandler = null
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [isExpand, allChildren])

  useEffect(() => {
    handleResize('init')
    init(allChildren)
    if (wrapDragable) {
      comInitMaxDisplayNum.current = 99999
    }
  }, [allChildren])

  const onFilterKeyDown = (e) => {
    // if (e.keyCode !== 13 || !e.ctrlKey) return;
    if (e.keyCode !== 13 || (e.ctrlKey && e.keyCode === 13)) return;
    if (bHideSearchStr) return;
    // TODO: 处理参照内查询区和单据查询区同时存在问题
    if (e.target._dataTransfer?.stopPropagation) return;
    if (isDesinger(props)) return; // 低代码不搜索
    // TODO: 不在可视区不搜索
    const filterDom = document.querySelector(`.yb-convenient-query[nodeid=${alias}]`)
    const isInClient = isElementInViewport(filterDom);
    if (!isInClient) return;
    handleSearch()
  }

  const isElementInViewport = (el) => {
    // 获取元素是否在可视区域
    let element = el;
    if (!el) element = document.querySelector(`.yb-convenient-query[nodeid=${alias}]`)
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) && rect.height > 0
    );
  }

  // 一行几列，根据 xs:<768px | sm:>=768px | md:>=992px | lg>=1200px
  //  lg={2} md={4} xs={6} sm={6}
  // spans:{lg:4,md:3,sm:2,xs:1}// 一行几个

  /**
   * @description 定义一个函数，给eventListener监听调用
   * @desc1 获取当前的视窗宽度，以及所在区间
   * @desc2 通过区间拿到spans对应的列数
   * @desc3 改变renderChildren
   *  */

  const init = (allChildren) => {
    // 销毁 autorun
    disposer.forEach(item => { item() });
    disposer.splice(0, disposer.length);
    const debouncedQuery = debounce(() => {
      handleSearch();
    }, AUTO_QUERY_DEBOUNCE)
    allChildren?.length > 0 && allChildren.map(node => {
      const { bAutoflt, storeField, defaultValue } = node.meta // bAutoflt: true值改变搜索 false手动搜索
      // bAutoflt = ctx?.getAuth?.(authId.bAutoflt)?.authFlag === false ? false : bAutoflt // 值改变搜索权限 不配置时默认可用
      if (![undefined, '', null].includes(defaultValue)) {
        // 设默认值
        // handleSearch();
        JSONSchema.copyCondition?.()
      }
      const _disposer = autorun(async () => {
        if (bAutoflt && storeField) {
          const value = JSONSchema.getFilterItemByName?.(storeField).value // 获取该项的值
          if (value === undefined) return
          // handleSearch();
          debouncedQuery()
        }
        // if (ctx?.getAuth?.(authId.bAutoflt)?.authFlag === false) {
        //   quantum?.utils.err('没有查询权限');
        // }
      })
      disposer.push(_disposer);
    })
  }

  // 排序 显示字段在前
  const resortChildren = (data) => {
    const childrenTem = JSON.parse(JSON.stringify(data))
    const tem = childrenTem.sort((a, b) => {
      const aV = a.visible;
      const bV = b.visible;
      return +aV > +bV ? -1 : 0;
    })
    return tem
  }

  // 窗口变化时计算占位
  const handleResize = (type) => {
    colNumCalc()
    forceRerender()
  }

  const colNumCalc = () => {
    let widthTem = document.querySelector(`.yb-convenient-query[uuid='${UUID.current}']`)?.clientWidth;
    if (!widthTem || widthTem === 0) widthTem = JSONSchema.hasQueryScheme ? document.body.clientWidth - 190 : document.body.clientWidth - 70;
    comInitMaxDisplayNum.current = 0
    if (widthTem < 500) {
      chLen.current = spans['xs'];
    } else if (widthTem < 800) {
      chLen.current = spans['sm'];
    } else if (widthTem < 1201) {
      chLen.current = spans['md'];
    } else if (widthTem < 1561) {
      chLen.current = spans['lg'];
    } else if (widthTem < 1921) {
      chLen.current = spans['xl'];
    } else {
      chLen.current = spans['xxl'];
    }
    let controlLenth = showChildren.current.length
    showChildren.current.forEach(item => {
      if (item.meta.controlType === 'FilterDateRangePicker') {
        controlLenth++
      }
    })
    if (!isDesinger(props) && controlLenth <= 3 && chLen.current > 3) chLen.current = 3; // 避免太空了
    showChildren.current.forEach(item => {
      if (item.meta.controlType === 'FilterDateRangePicker' && chLen.current === 1) {
        chLen.current++
      }
    })
  }

  // 重置
  const handleReset = async () => {
    // 拦截
    if (await props.onBeforeReset?.() === false) return;

    const _allChildren = cloneDeep(allChildren)
    _allChildren.forEach(item => {
      item.value = item.meta.defaultValue || undefined;
      item.operator = item.operator?.operator;
      return item
    })
    JSONSchema.setCondition?.(_allChildren)
    JSONSchema.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800CD', '重置', undefined, { returnStr: true }) || '重置')
    props?.onReset ? props.onReset?.() : handleSearch(true)
  }

  const handleAdvance = () => {
    if (isDesinger(props)) return
    setIsEdit(true)
    setShowModal(true)
  }

  // 搜索
  const handleSearch = (isFromReset = false) => {
    const validateResult = JSONSchema.validate?.()
    if (validateResult.length) {
      return JSONSchema.utils.message.danger({
        content: validateResult.map((item) => {
          return <div key={item.name}>{item.message}</div>;
        })
      });
    }
    JSONSchema.copyCondition?.(); // TODO 后期可以考虑收到onSearch中
    // 拦截
    if (props.onBeforeSearch?.() === false) return;
    if (!isFromReset) JSONSchema.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_189F4BF005A80088', '搜索', undefined, { returnStr: true }) || '搜索')
    props.onSearch ? props.onSearch?.() : JSONSchema.onSearch?.()
  }

  // 展开全部
  const handleShow = () => {
    setExpand(!isExpand);
  }

  // 固定查询区
  const handleFixed = () => {
    setFix(!isFixed)
  }

  // 渲染查询区
  const renderContorl = (renderData, isHiddenBtn) => {
    const buttonStyle = { display: 'flex', height: 32, alignItems: 'center', position: 'absolute', right: '12px' }
    if (isExpand) buttonStyle.marginLeft = 'auto'
    const advanceButtonStyle = ['zh_CN', 'zh_TW'].includes(window.lang?.lang) ? { backgroundColor: 'transparent', padding: 0, minWidth: 30 } : { backgroundColor: 'transparent', padding: '0 0 0 8px', minWidth: 30 }
    const controlsStyle = ['zh_CN', 'zh_TW'].includes(window.lang?.lang) ? { width: '100%' } : { width: '100%', paddingRight: '56px' }
    return (
      <div style={{ width: '100%' }}>
        <Col span={grid} style={controlsStyle}>
          {/* 过滤条件区 */}
          {renderItem(renderData)}
        </Col>
        {/* 查询/重置 按钮区 */}
        {isHiddenBtn !== 'hidden' && !wrapDragable && <div style={buttonStyle}>
          {!bHideSearchStr &&
            <Button fieldid={getFieldId() + 'Search'} style={{ width: 36, height: 28, marginRight: 8 }} colors="dark"
              icon={<Icon style={{ fontSize: 14 }} type='uf-search' />} onClick={() => handleSearch()}
            />}
          {!btnRestorelsHidden &&
            <Button fieldid={getFieldId() + 'Rest'}
              type="text" style={advanceButtonStyle} onClick={handleReset} >{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800CD', '重置', undefined, { returnDom: true, placement: 'top' })}</Button>}
          {!btnAdvanceIsHidden &&
            <Button fieldid={getFieldId() + 'Advance'}
              type="text" style={advanceButtonStyle} onClick={handleAdvance} >{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A5CF43E04C80008', '高级', undefined, { returnDom: true, placement: 'top' })}</Button>}
        </div>}
      </div>
    )
  }

  // 渲染每一项
  const renderItem = (renderData) => {
    return renderData?.map(ch => {
      const tempItem = JSONSchema.expressionTransfer?.(ch.meta) || {}
      if (tempItem.visible === false) return null
      if (!ch.meta.parentAlias) {
        ch.meta.parentAlias = 'convenientquery'; // 查询区的组件统一加parentAlias
      }
      ch.meta.readOnly = false; // 查询区的组件都是编辑态
      const controls = JSONSchema.render?.(ch, isDesinger(props))
      return (
        <Col
          key={ch?.meta.alias}
          className={designDomClassName}
          style={getStyle(ch, wrapDragable, chLen.current, comInitMaxDisplayNum.current < showChildren.current?.length)}>
          {controls}
        </Col>
      )
    })
  }

  const getFieldId = () => {
    const { fieldid, fieldidPrefix } = props || {};
    return fieldid || fieldidPrefix;
  };

  const closeAddModal = () => {
    setShowModal(false)
  }

  // 获取渲染字段数据
  const getRenderData = () => {
    if (isDesinger(props)) {
      return [...originChildren?.filter(item => item.activated !== false) || []]
    } else {
      if (isExpand) {
        return [...allChildren?.filter(item => item.activated !== false) || []]
      } else {
        let renderContorl = []
        showChildren.current = []
        allChildren?.forEach(item => {
          const tempItem = JSONSchema.expressionTransfer?.(item.meta) || {}
          if (tempItem.visible !== false && item.meta.visible !== false && (item.activated !== false)) {
            showChildren.current.push(item)
          }
        })// 过滤不展示和待选区数据
        colNumCalc()
        comInitMaxDisplayNum.current = props.initMaxDisplayNum || chLen.current; // 展示数量
        if (props.initMaxDisplayNum) {
          comInitMaxDisplayNum.current = props.initMaxDisplayNum; // 设置展示的数量
          renderContorl = resortChildren(showChildren.current).slice(0, comInitMaxDisplayNum.current) // 只取第一行数据展示
        } else {
          // 计算查询区内每个元素多占几列
          let colWidth = 0;
          let countWidth = 0;
          renderContorl = resortChildren(showChildren.current).slice(0, chLen.current) // 只取第一行数据展示
          renderContorl.forEach(item => {
            if (countWidth < chLen.current && item.meta.iColWidth) {
              countWidth += item.meta.iColWidth; // 总占位列数
              colWidth += item.meta.iColWidth - 1; // 减去本来就占的一列
            } else {
              countWidth += 1; // 总占位列数
            }
          })
          comInitMaxDisplayNum.current = chLen.current - colWidth // 默认展示数量
          renderContorl = renderContorl.slice(0, comInitMaxDisplayNum.current)
        }
        return [...renderContorl.filter(item => item.activated !== false) || []]
      }
    }
  }

  const getFilterDomPosition = (classname) => {
    const id = JSONSchema.diworkCode || JSONSchema.serviceCode;
    let container = document.getElementById(id) || document.body;
    if (classname) container = container.querySelector(classname);
    // if (this.refCode) container = container && container.querySelector('.modal-body') || container;
    const domobj = (container && container.getBoundingClientRect()) || {}
    return domobj
  }

  const getNameLength = (name) => {
    let num = 0;
    for (let i = 0; i < name.length; i++) {
      const charlen = name.charCodeAt(i);
      if ((charlen >= 0x0001 && charlen <= 0x007e) || (charlen >= 0xff60 && charlen <= 0xff9f)) {
        num++;
      } else {
        num += 2;
      }
    }
    return num * 7 + 25
  }

  const getSearchCommons = () => {
    const commonVOs = JSONSchema.getShowSearchCommons?.()
    const parentDOM = getFilterDomPosition('.yb-convenient-query')
    const parentDOMWidth = parentDOM?.width || document.body.clientWidth
    let tagslength = 0;
    const tags = []
    const more = []
    if (commonVOs.length > 0) {
      commonVOs.forEach(filterItem => {
        const { v1, v2, op, caption, name } = filterItem
        const { disabled, required } = filterItem.meta
        let showValue = caption + ': ' + v1;
        if (op === 'between' && v2) {
          showValue += ' ～ ' + v2//@notranslate
        }
        const nameLength = getNameLength(showValue)
        tagslength += (nameLength > 320 ? 320 : nameLength)
        tagslength += 10 // 间距
        const className = (disabled || required) ? 'tag-ynf-close show-search-conditions-tags' : 'show-search-conditions-tags'
        const tagItem = <Tag
          className={className}
          closable={!(disabled || required)}
          key={name}
          onClose={(e) => {
            e.preventDefault()
            JSONSchema.deleteShowSearchCommon?.(filterItem)
          }}
        >{showValue}</Tag>
        if (tagslength < parentDOMWidth - 100) {
          tags.push(<Tooltip className='show-search-condition-tooltips' placement='bottom' inverse overlay={showValue}>
            {tagItem}
          </Tooltip>)
        } else {
          more.push(<Tooltip className='show-search-condition-tooltips' placement='left' inverse overlay={showValue}>
            {tagItem}
          </Tooltip>)
        }
      })
    } else {
      tags.push(<span>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A5CF43E04C80009', '空', undefined, { returnStr: true })}</span>)
    }
    const moreTags = <Popover
      trigger='hover'
      overlayStyle={{ width: '340px', zIndex: 2000 }}
      getPopupContainer={(triggerNode) => { 
        const id = JSONSchema.diworkCode || JSONSchema.serviceCode;
        return document.getElementById(id) || document.body || triggerNode.parentNode
      }}
      placement='bottomRight'
      content={more}
      overlayClassName='show-search-conditions-pop'
    >
      <span className='show-search-conditions-tags more-tags'>+{more.length}</span>
    </Popover>
    return (
      <div className='show-search-conditions'>
        <span className='show-search-conditions-title'>
          {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A5CF43E04C8000A', '已选条件:', undefined, { returnStr: true })}
        </span>{tags}{more.length ? moreTags : null}</div>
    )
  }

  // if (visible === false) return;

  const filterSchemeJSONSchema = JSONSchema.getJSONSchema('queryscheme', false)
  const filterModalProps = {
    showModal,
    isEdit,
    currentId: filterSchemeJSONSchema.currentScheme?.solutionId || 'systemScheme',
    conditionsList: filterSchemeJSONSchema?.getCandidateConditionsList?.(cloneDeep(JSONSchema.getContitionList?.()), { parentAlias: props.parentAlias }),
    closeAddModal,
    parentAlias: props.parentAlias,
    getSolutionDataList: filterSchemeJSONSchema?.getSolutionDataList?.bind?.(this),
    dataSource: props.dataSource,
    chooseScheme: (value) => {
      filterSchemeJSONSchema.targetScheme = value
      filterSchemeJSONSchema.updateScheme++;
    },
    fieldid: `${getFieldId()}|filterModal`,
    JSONSchema: JSONSchema.getJSONSchema('filtermodal'),
    bAdvance: true,
    dataLoader
  }
  if (JSONSchema.hasQueryScheme) {
    filterModalProps.deleteScheme = (solutionId) => {
      JSONSchema.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A8EA5FE05580008', '删除查询方案', undefined, { returnStr: true }) || '删除查询方案')
      filterSchemeJSONSchema?.deleteScheme?.(solutionId)
    }
    filterModalProps.setDefaultScheme = (solutionId, e) => {
      JSONSchema.operationLog?.(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1A8EA85405580003', '设置默认查询方案', undefined, { returnStr: true }) || '设置默认查询方案')
      filterSchemeJSONSchema?.setDefaultScheme?.(solutionId, e)
    }
    filterModalProps.schemeList = filterSchemeJSONSchema?.schemeList
  }

  return (
    <div
      {...degignDomAttr}
      className={`${designDomClassName} yb-convenient-query ${wrapDragable ? "yb-wrap-dragable" : ""}`}
      nodeid={alias}
      uuid={UUID.current}
      style={{
        marginBottom: !!visible && comInitMaxDisplayNum.current < showChildren.current?.length ? 8 : 0,
        paddingBottom: !!visible && comInitMaxDisplayNum.current < showChildren.current?.length ? 8 : 0,
        ...cStyle
      }} >
      {!!visible && <div>
        <Row className={isExpand ? "" : "hide-botton-line"} grid={grid}
          gutter={[16, 0]}
          style={{
            width: "100%",
            marginLeft: 0,
            marginRight: 0,
            padding: `8px 0 0`,
            backgroundColor: noBackground ? '' : '#f9fbff',
            maxHeight: document.body.clientHeight / 4,
            overflowY: 'auto'
          }}
        >
          {/* 虚线以上 */}
          {renderContorl(getRenderData())}
          {/* 虚线以下 */}
          {
            isDesinger(props)
              ? <>
                <div className='waiting-header'><span className='mid-line'></span>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800CC', '待选字段', undefined, { returnDom: true, placement: 'top' })}<span className='mid-line'></span></div>
                {renderContorl(originChildren?.filter(item => item.activated === false), 'hidden')}
              </>
              : props.showSearchCommon && getSearchCommons()
          }
        </Row>
        {!isDesinger(props) && comInitMaxDisplayNum.current < showChildren.current?.length &&
          <Row className={isExpand ? "" : "hide-botton-line"} grid={grid} style={{ marginBottom: -16 }}>
            <Col span={grid} className='line-wrap-fluid'>
              <div className='botton_line'>
                <Button style={{ marginBottom: '2px' }} className={isFixed ? 'disappear' : 'down'} icon={<Icon rotate={isExpand ? 180 : 0} fieldid={getFieldId() + 'Fixed'} type="uf-anglearrowdown" />} onClick={handleShow} />
                <Button style={{ marginBottom: '2px' }} className={isExpand ? (isFixed ? 'fixed' : 'nofixed') : 'disappear'} icon={<Icon rotate={isFixed ? 45 : 0} fieldid={getFieldId() + 'Expand'} type="uf-dingzhu_xiao" />} onClick={handleFixed}></Button>
                <div className={isExpand ? (isFixed ? 'disappear' : 'hotbackground2') : 'hotbackground1'} onClick={handleShow}></div>
                <div className={isExpand ? (isFixed ? 'fixedline' : 'newline2') : 'newline1'}></div>
              </div>
            </Col>
          </Row>
        }
      </div>}
      {!btnAdvanceIsHidden && showModal && <FilterModal {...filterModalProps} />}
    </div>
  )
}

export default observer(ConvenientQuery);
